import React, { useState, useEffect } from "react";
import { json, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

function CompanyDetail() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [registerDate, setRegisterDate] = useState("");
  const [companyCode, setCompanyCode] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyMobilePhone, setCompanyMobilePhone] = useState("");
  const [salesOrderPriceUsd, setSalesOrderPriceUsd] = useState("");
  const [salesOrderPriceIdr, setSalesOrderPriceIdr] = useState("");
  const [quotationPriceUsd, setQuotationPriceUsd] = useState("");
  const [quotationPriceIdr, setQuotationPriceIdr] = useState("");
  const [quotationMsaDate, setQuotationMsaDate] = useState("");
  const [salesList, setSalesList] = useState([]);
  const [selectedSales, setSelectedSales] = useState("");

  const resource = "company-detail";

  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    getCustomerDetail(searchParams.get("companyId"));
  }, []);

  const getCustomerDetail = async (companyId) => {
    try {
      const response = await fetch(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/company/company-detail?companyId=${companyId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      const data = result[0];

      if (!response.ok) {
        setError(data.message || "Failed to fetch session token data");
        throw new Error(data.message || "Failed to fetch session token data");
      }

      setRegisterDate(formatDate(data.register_date));
      setCompanyCode(data.company_code);
      setCompanyName(data.company_name);
      setCompanyAddress(data.company_address);
      setCompanyPhone(data.company_phone);
      setCompanyMobilePhone(data.company_mobile_phone);
      setSelectedSales(data.company_sales_pic);
      setSalesOrderPriceUsd(data.sales_order_price_usd);
      setSalesOrderPriceIdr(data.sales_order_price_idr);
      setQuotationPriceUsd(data.quotation_price_usd);
      setQuotationPriceIdr(data.quotation_price_idr);
      setQuotationMsaDate(formatDate(data.quotation_msa_date));
    } catch (error) {
      console.error("Error get customer detail:", error.message);
      setError("Error get customer detail: " + error.message);
    }
  };

  const formatDate = (datetime) => {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    setRegisterDate(registerDate);
  }, [registerDate]);

  const handleBackClick = () => {
    navigate("/company-list");
  };

  const formatCurrency = (value) => {
    // Gunakan Intl.NumberFormat untuk memformat angka
    const formatted = new Intl.NumberFormat("id-ID", {
      maximumFractionDigits: 9, // Tidak ada angka desimal
    }).format(value);

    return formatted; // Langsung kembalikan hasil tanpa simbol mata uang
  };

  useEffect(() => {
    loadSalesList();
  }, []);

  const loadSalesList = async () => {
    //Role Sales
    const roleId = 2;
    const result = await axios.get(
      `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/internal/find-by-role?roleId=${roleId}`
    );
    const data = result.data;
    setSalesList(data);
  };

  return (
    <div className="container-order-input">
      <h1>Cross Connect Company Detail</h1>
      <form>
        <div className="order-information-order-input">
          <div className="title-order-input">
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="textbox-gray">
              <label htmlFor="registerDate">Register Date</label>
              <input
                text="date"
                placeholder={registerDate}
                disabled
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="companyCode">Company Code</label>
              <input
                type="text"
                placeholder={companyCode}
                disabled
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="companyName">Company Name</label>
              <input
                type="text"
                placeholder={companyName}
                disabled
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox">
              <label htmlFor="companyAddress">Company Address</label>
              <textarea
                placeholder={companyAddress}
                style={{
                  backgroundColor: "lightgrey",
                  color: "black",
                  paddingLeft: "5px",
                }}
                disabled
              ></textarea>
            </div>
            <div className="textbox-gray">
              <label htmlFor="companyPhone">Company Phone</label>
              <input
                type="tel"
                id="companyPhone"
                name="companyPhone"
                placeholder={companyPhone}
                pattern="0\d{6,}"
                disabled
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="companyMobilePhone">Company Mobile Phone</label>
              <input
                type="tel"
                id="companyMobilePhone"
                name="companyMobilePhone"
                placeholder={companyMobilePhone}
                pattern="08\d{8,}"
                disabled
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="comboBox">Company Sales PIC</label>
              <select
                id="comboBox"
                name="options"
                value={selectedSales}
                disabled
              >
                <option value="" disabled>
                  Select Company Sales PIC
                </option>
                {salesList.map((item) => (
                  <option
                    key={item.xcp_internal_id}
                    value={item.xcp_internal_id}
                  >
                    {item.xcp_internal_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="textbox-gray">
              <label htmlFor="salesOrderPriceUsd">
                Sales Order Price (USD){" "}
              </label>
              <input
                type="text"
                placeholder={formatCurrency(salesOrderPriceUsd)}
                disabled
                style={{ textAlign: "right", paddingRight: "5px" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="salesOrderPriceIdr">
                Sales Order Price (IDR){" "}
              </label>
              <input
                type="text"
                placeholder={formatCurrency(salesOrderPriceIdr)}
                disabled
                style={{ textAlign: "right", paddingRight: "5px" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="quotationPriceUsd">Quotation Price (USD) </label>
              <input
                type="text"
                placeholder={formatCurrency(quotationPriceUsd)}
                disabled
                style={{ textAlign: "right", paddingRight: "5px" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="quotationPriceIdr">Quotation Price (IDR) </label>
              <input
                type="text"
                placeholder={formatCurrency(quotationPriceIdr)}
                disabled
                style={{ textAlign: "right", paddingRight: "5px" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor=" quotationMsaDate">Quotation MSA Date </label>
              <input
                type="text"
                placeholder={quotationMsaDate}
                disabled
                style={{ paddingLeft: "5px" }}
              />
            </div>
          </div>
        </div>
        <input
          type="button"
          className="btn-submit-order-input"
          value="Back"
          onClick={handleBackClick}
        />
      </form>
    </div>
  );
}

export default CompanyDetail;
